import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class SecuritySettingsService {
  constructor(private http: HttpClient) {}

  public fetchSecuritySettings(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/SETTINGS_SECURITY`
    return this.http.get(url, {})
  }

  public updateSecuritySettings(payload: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/SETTINGS_SECURITY`
    return this.http.put(url, payload)
  }
}
